import { combineReducers } from 'redux';
import benchmarkStoreReducer from './benchmark-store';

export default combineReducers({
  store: benchmarkStoreReducer,
});
